module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gardenlife Pro","short_name":"Gardenlife","description":"Gardenlife Pro reviews everything being it a lawn mower, chainsaw, grill or the latest oil for your power tool, so that you can make the best decision.","orientation":"any","start_url":"/","background_color":"#ffffff","theme_color":"#42ffa7","display":"minimal-ui","icon":"src/assets/gardenlifepro-icon-512x512.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1200},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"150951135559776"},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.gardenlifepro.com"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-5C3HT35","includeInDevelopment":false},
    }]
